export const MANDATAIRE_PAYEUR = 'MandatairePayeur';